<template>
  <div class="leaders">
    <div class="pd-t30 pd-l50 pd-b50">

      <div class="details-box">

        <div class="mg-b50">
          <img class="max-w100p" :src="'/static/images/company/leaders/leaders_01.jpg'" alt="">
        </div>

      </div>

      <div class="leaders-list">
        <div class="clear mg-b100 pos-relative leaders-list-item" v-for="(item, index) in leaders">
          <div class="fl w200 pos-relative leaders-list-pic">
            <img class="max-w100p" :src="item.pic" alt="">
            
            
            <div class="w100p pos-abs l0 b0 position">
              <div class="position-desc">
                <div class="position-desc-text">
                  {{ item.position }}
                </div>
              </div>
              <div class="real-name">
                {{ item.name }}
              </div>
  
              <img class="pos-abs r0 b0" :src="publicPath + 'static/images/company/leaders/icon_position_bg.png'" alt="">
            </div>
          </div>
          <div class="h100p l220 t0 r0 b0 pos-abs">
            <div class="h100p display-table leaders-list-text-box">
              <div class="display-table-cell v-m leaders-list-text" v-html="item.text"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "leaders",

  data() {
    return {
      leaders: [
        // {
        //   pic: '/static/images/company/leaders/leaders_item_01.jpg',
        //   position: '董事长',
        //   name: '►►► 王铠',
        //   text: '<p>曾任北京市教委校办产业管理中心副主任职务。自2003年起至今致力于保险中介行业，历任北京联合保险经纪有限公司总经理、经营管理委员会主任，北京君恒保险公估有限责任公司董事长，鼎力（北京）保险经纪有限公司执行董事，具有丰富的保险中介机构经营管理经验，在教育行业保险与风险管理方面具有深刻的认识和丰富的实践。</p>'
        // },

        {
          pic: '/static/images/company/leaders/leaders_item_02.jpg',
          position: '总经理',
          name: '►►► 董镯',
          text: '<p>从事保险经纪行业工作近20年。中国保险行业“千人计划”核心人才、高级企业风险管理师，担任多个国内外重大保险项目负责人，在国内市场首创多款保险产品，具有丰富的从业经验和技术、管理能力。曾任江泰保险经纪公司财产保险技术负责人，负责产品研发、保险安排等专业技术工作，主导参与了海内外众多保险经纪项目，有着丰富的风险管理经验。</p>'
        },

        {
          pic: '/static/images/company/leaders/leaders_item_05.jpg',
          position: '首席顾问',
          name: '►►► 陆华',
          text: '<p>从业保险经纪近40年，具有丰富的从业和管理经验，具备把外国先进的保险经纪技术和中国的保险经纪实践结合起来的操作经验和技术能力。曾任江泰保险经纪股份有限公司总裁，江泰再保险经纪有限公司董事长，班陶氏有限公司北京地区经理，韦莱科伦有限公司北京代表处执行代表、首席代表，塞奇维克保险与风险管理咨询（中国）有限公司总经理，达信保险与风险管理咨询（中国）有限公司总经理。</p>'
        }
      ]
    }
  }
}
</script>

<style>
.leaders .details-box p {
  color: #7a6a56;
  font-size: 16px;
  line-height: 30px;
}

.leaders .leaders-list-pic {
  border-radius: 0 0 6px 0;
  overflow: hidden;
}

.leaders .leaders-list-text {
  color: #7a6a56;
  font-size: 16px;
  line-height: 30px;
}
  
  .leaders .position {
    background: #231815;
    height: 56px;
  }
  .leaders .position-desc,
  .leaders .real-name {
    color: #fff;
    font-size: 16px;
  }
  .leaders .position-desc {
    background: #d8c18a;
    border-radius: 6px 0 6px 0;
    display: inline-block;
    line-height: 1;
    margin-top: -10px;
    padding: 8px 20px 8px 40px;
    vertical-align: middle;
  }

.leaders .position-desc-text {
  padding-left: 10px;
  position: relative;
}

.leaders .position-desc-text::before {
  background: #fff;
  border-radius: 50%;
  content: '';
  width: 6px;
  height: 6px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
}
  
  
  .leaders .real-name {
    height: 34px;
    line-height: 34px;
    padding-left: 30px;
  }
  
</style>